import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';
import { instances, type InstanceLink } from '../api';

/** Wie die Art einer Verbindung aus Sicht der jeweiligen Seite heißt. */
export function rollenText(l: InstanceLink): string {
  return l.rolle === 'wirt' ? 'bettet ein' : 'eingebettet in';
}

export function partnerName(p: { subdomain: string | null; domain: string | null; stackName: string | null }): string {
  return [p.subdomain, p.domain].filter(Boolean).join('.') || p.stackName || '—';
}

/**
 * Mit wem diese Instanz verbunden ist — oben auf jeder Instanzseite, nicht nur
 * im Reiter.
 *
 * Anlass 03.11.2026: bei utb stand die Brücke zur eLibrary nur auf der Seite von
 * ojfm. Wer die eLibrary ansah, hielt sie für unverbunden. Dieselbe Abfrage wie
 * der Reiter „Verknüpfungen", also kein zweiter Weg zum Server.
 */
export default function VerknuepfungsLeiste({
  instanceId,
  onOeffnen,
}: {
  instanceId: string;
  onOeffnen: () => void;
}) {
  const { data } = useQuery({
    queryKey: ['instances', instanceId, 'links'],
    queryFn: () => instances.getLinks(instanceId),
  });
  const links = data?.links ?? [];
  if (!links.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
      <button
        type="button"
        onClick={onOeffnen}
        className="inline-flex items-center gap-1 font-medium text-slate-600 hover:text-slate-800"
      >
        <Link2 size={13} /> Verknüpft:
      </button>
      {links.map((l) => (
        <Link
          key={l.id}
          to={`/instances/${l.partner.id}`}
          title={`${rollenText(l)} · ${l.kind}`}
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-surface px-2.5 py-0.5 hover:border-brand-400 hover:text-brand-700"
        >
          <span className="text-slate-400">{rollenText(l)}</span>
          <span className="font-mono text-slate-700">{partnerName(l.partner)}</span>
          <span className="text-slate-400">· {l.partner.productName}</span>
        </Link>
      ))}
    </div>
  );
}
